import { showPrivacyPolicy, showTOS, showTOU } from './components';

function formatManagerEmail(payload = {}, formValues = {}, companyData = {}) {
  const { managerEmail } = formValues;
  const { sendEmailsToManager } = companyData;

  if (sendEmailsToManager) payload.managerEmail = managerEmail;

  return payload;
}

export function formatSpecialFieldsForApiCall(
  payload = {},
  formValues = {},
  companyData = {}
) {
  payload = { ...payload };
  payload = formatManagerEmail(payload, formValues, companyData);

  return payload;
}

export function formatAcceptTermsForApiCall(payload, acceptTerms, registerCompany) {
  const {
    termsOfUse,
    termsOfSubscription,
    privacyPolicy,
    commercialPurposes
  } = acceptTerms;

  const data = {
    ...payload,
    commercialOffers: commercialPurposes,
    termsAndConditionsAcceptance: {
      termsOfUseAccepted: termsOfUse,
      termsOfSubscriptionAccepted: termsOfSubscription,
      privacyPolicyRead: privacyPolicy
    }
  };

  if (registerCompany) {
    const fields = data.termsAndConditionsAcceptance;

    if (!showTOU(registerCompany)) {
      delete fields.termsOfUseAccepted;
    }

    if (!showTOS(registerCompany)) {
      delete fields.termsOfSubscriptionAccepted;
    }

    if (!showPrivacyPolicy(registerCompany)) {
      delete fields.privacyPolicyRead;
    }
  }

  return data;
}

export function getErrorStatus(action) {
  const { error: errorResp } = action;
  const { response } = errorResp || {};
  const { status: errorStatus } = response || {};

  return errorStatus;
}
